import { requestIdle } from "@/lib/requestIdle";
import { ready } from "@/lib/ready";
import { on } from "@/lib/dom/on";
import { toggleClass } from "@/lib/dom/toggleClass";
import { open, close  } from "@/lib/easy-dialog";

import { initLiveChat } from "./livechat"
import { initSubscribe } from "./subscribe"


ready(() => {

  //2秒内，在空闲时间加载
  requestIdle(() => {
    initLiveChat();
  }, 2000);
  initSubscribe();

  on('.accessibility-link a', 'click', (e: MouseEvent) => {
    toggleClass(document.querySelector('.accessibility-dropdown') as HTMLElement,'is-active')
  });
  on('#ContrastAccessibility', 'click', (e: MouseEvent) => {
    const currentTarget = e.currentTarget as HTMLInputElement;
    setTimeout(() => {
      open({
        container: {
          header: '',
          content: '<div><div style="width:300px;height:128px;" class="Font_38"><span style="top:50%;position: absolute;left: 50%;margin: -11px 0 0 -53px;">loading...</span></div></div>'
        }
      });
      const opt = currentTarget.checked ? 'set' : 'remove';
      fetch('/ajax/pageheader.aspx?type=SetWCAGCookie&opt=' + opt,
        {
          method: 'GET'
        }).then(res => {
          if (res.ok) {
            window.location.reload();
          }
        });
      
    }, 0);
  });
})